import { faSitemap } from "@fortawesome/pro-regular-svg-icons/faSitemap";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconHierarchy: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faSitemap} />;
};
